<div class="tpn-list">
  <ul *ngIf="tpns.length" class="tpn-chips" aria-label="TPNs">
    <li *ngFor="let tpn of tpns" class="tpn-chip" data-cy="tpn">
      <span>{{ tpn }}</span>
      <button
        type="button"
        class="tpn-chip-remove"
        [attr.aria-label]="'Remove TPN ' + tpn"
        [disabled]="isDisabled"
        (click)="remove(tpn)"
        data-cy="remove-tpn-button"
      >
        <i class="bi bi-x"></i>
      </button>
    </li>
  </ul>

  <div class="tpn-add">
    <input
      pInputText
      type="text"
      class="tpn-add-input"
      [id]="inputId"
      [formControl]="newTpn"
      maxlength="255"
      placeholder="Enter a TPN"
      aria-label="New TPN"
      data-cy="new-tpn-input"
      (keydown.enter)="$event.preventDefault(); add()"
      (blur)="add()"
    />
    <button
      pButton
      type="button"
      class="tpn-add-button"
      icon="bi bi-plus-lg"
      label="Add"
      [disabled]="isDisabled || !newTpn.value.trim()"
      (click)="add()"
      data-cy="add-tpn-button"
    ></button>
  </div>

  <small *ngIf="isDuplicate" class="text-danger" data-cy="duplicate-tpn-error">This TPN is already in the list.</small>
</div>
